export const clearLocalStorage = () => {
  window.localStorage.clear();
};

export const formatDuration = duration => {
  let parts = [];

  if (!duration || duration.toISOString() === 'P0D') return;

  if (duration.years() >= 1) {
    const years = Math.floor(duration.years());
    parts.push(years + ' ' + (years > 1 ? 'years' : 'year'));
  }

  if (duration.months() >= 1) {
    const months = Math.floor(duration.months());
    parts.push(months + ' ' + (months > 1 ? 'months' : 'month'));
  }

  if (duration.days() >= 1) {
    const days = Math.floor(duration.days());
    parts.push(days + ' ' + (days > 1 ? 'days' : 'day'));
  }

  return parts.join(', ');
};

export * as atlassian from './atlassian';
export * as jira from './jira';
export * as metrics from './metrics';
